// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__pWUGb","content":"styles_content__30KVq","checkbox":"styles_checkbox__20eRs","checkboxLabel":"styles_checkboxLabel__2w8RY"};